import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from './manage-survey.model';

export const ACTIVITY_LOG_HANDLERS = [
  on(
    ManageSurveyActions.loadActivityLogs,
    (state): ManageSurveyState => ({
      ...state,
      activityLogsLoading: true,
      activityLogsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadActivityLogsSuccess,
    (state, { activityLogs }): ManageSurveyState => ({
      ...state,
      activityLogs,
      activityLogsLoading: false,
      activityLogsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadActivityLogsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      activityLogs: [],
      activityLogsLoading: false,
      activityLogsError: error,
    }),
  ),

  on(
    ManageSurveyActions.resetActivityLogs,
    (state): ManageSurveyState => ({
      ...state,
      activityLogs: [],
      activityLogsLoading: false,
      activityLogsError: null,
    }),
  ),
];
